import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FadeTransitionComponent } from './fade-transition.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    FadeTransitionComponent,
  ],
  exports: [
    FadeTransitionComponent,
  ]
})
export class TransitionsModule { }
